import { render, staticRenderFns } from "./TruckDetailDrawer.vue?vue&type=template&id=34d87a26&scoped=true"
import script from "./TruckDetailDrawer.vue?vue&type=script&lang=js"
export * from "./TruckDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./TruckDetailDrawer.vue?vue&type=style&index=0&id=34d87a26&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d87a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d87a26')) {
      api.createRecord('34d87a26', component.options)
    } else {
      api.reload('34d87a26', component.options)
    }
    module.hot.accept("./TruckDetailDrawer.vue?vue&type=template&id=34d87a26&scoped=true", function () {
      api.rerender('34d87a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/TruckDetailDrawer.vue"
export default component.exports